import api from "../../api/api";

//*------------------Post API for saving the gamified quiz data---------------------------
export const saveGamifiedQuiz = async (body) => {
  return await api.post(`saveMasterTchTrainingGamifiedModule`, body);
};

//*-----------------GET API for fetching all the saved quizes -----------------------------
export const getAllGamifiedQuizzes = async (topicId) => {
  return await api.get(
    `getMasterTchTrainingGamified/${topicId}/gamified` //The quizType will be gamified
  );
};

//&---------------Update API to update the data in the database----------------------
export const updateGamifiedQuiz = async (body) => {
  return await api.post(`updateMasterTchTrainingGamifiedModule`, body);
};

//!---------------------Delete the gamifiedQuiz from the database--------------------
export const deleteGamifiedQuiz = async (body) => {
  return await api.post(`updateMasterTchTrainingGamifiedModule`, body);
};
